export const STAGGERED_CHILDREN_CONTAINER_VARIANTS = {
  hidden: { transition: { duration: 0.3, staggerChildren: 0.1 } },
  show: {
    transition: {
      duration: 0.3,
      staggerChildren: 0.1,
    },
  },
};

export const STAGGERED_CHILD_VARIANTS = {
  hidden: { opacity: 0 },
  show: { opacity: 1 },
};
